// extracted by mini-css-extract-plugin
export default {"table_title_gray":"skill-table_table_title_gray__G0Sc-","table_row":"skill-table_table_row__84cWW","table_row_title":"skill-table_table_row_title__awr22"};